import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-full pb-8 bg-clay-50" }
const _hoisted_2 = { class: "w-full mx-auto" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "py-12 sm:py-12" }
const _hoisted_5 = { class: "pb-16 mx-auto mt-10 text-center" }
const _hoisted_6 = { class: "mb-4 text-gray-600" }
const _hoisted_7 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_8 = { class: "flex items-end justify-center min-h-full p-4 sm:items-center sm:p-0" }
const _hoisted_9 = { class: "flex items-center justify-center w-12 h-12 mx-auto bg-red-100 rounded-full" }
const _hoisted_10 = { class: "mt-3 sm:mt-5" }
const _hoisted_11 = { class: "mt-2" }
const _hoisted_12 = { class: "mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "bg-white" }
const _hoisted_15 = { class: "relative px-6 isolate lg:px-8" }
const _hoisted_16 = { class: "py-16 mx-auto max-w-7xl" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "max-w-lg mx-auto mt-8" }
const _hoisted_19 = { class: "mb-5 text-clay-800" }
const _hoisted_20 = { class: "relative max-w-3xl mx-auto my-5 bg-white rounded-4xl" }
const _hoisted_21 = { class: "relative z-10 pb-32 mx-auto" }
const _hoisted_22 = { class: "mx-auto text-center max-w-7xl" }
const _hoisted_23 = {
  key: 0,
  class: "min-h-full px-4 bg-white sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8"
}
const _hoisted_24 = {
  key: 1,
  class: "max-w-md py-12 mx-auto mt-10 text-center sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8"
}
const _hoisted_25 = { class: "max-w-md mx-auto mt-5" }
const _hoisted_26 = { class: "flex items-center mb-4" }
const _hoisted_27 = ["id", "name", "value"]
const _hoisted_28 = ["for"]
const _hoisted_29 = { class: "block leading-6 text-gray-900" }
const _hoisted_30 = { class: "mt-1" }

import { ref} from 'vue';
import {
    Dialog,
    DialogPanel, DialogTitle,
    TransitionChild,
    TransitionRoot
} from '@headlessui/vue';
import {client, trackEvent} from '@/shared';
import {CancelProMembership, SubmitCancelProMembershipSurvey,} from "@/dtos";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import {FlagIcon} from "@heroicons/vue/20/solid";
import SaButton from "@/main/components/SaButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CancelMembership',
  props: {
    subscription: {},
    email: {}
  },
  setup(__props: any) {

const props = __props;

const subscription = props.subscription;
const membershipEndsOn = subscription?.currentPeriodEndFormatted;

const isOpen = ref(false);
const closeConfirmation = async () => {
    isOpen.value = false;
}
const showConfirmation = async () => {
    isOpen.value = true;
};

const processing = ref(false);
const cancelled = ref(false);

const cancellationResponseStatus = ref(null);
const cancelSubscription = async () => {
    processing.value = true;

    await client.post(new CancelProMembership())
        .then(r => {
            processing.value = false;
            cancelled.value = true;
            trackEvent( 'downgrade_requested', {
                subscription_id: subscription.id,
                subscription_name: subscription.name,
                subscription_ends_on: subscription.currentPeriodEndFormatted
            }, true, false);
        })
        .catch(e => {
            cancellationResponseStatus.value = e.responseStatus;
        });

    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}

const reasonOptions = [
    'Technical problems',
    'I didn\'t use it enough',
    'The subscription is too expensive',
    'I can\'t find the specific content that I want to read',
    'Other',
];
const selectedReason = ref('');
const comments = ref("");
const submitSurveySuccessful = ref(false);
const surveyResponseStatus = ref(null);
const submitSurvey = async () => {
    const data = new SubmitCancelProMembershipSurvey({
        reason: selectedReason.value,
        comments: comments.value
    });
    await client.post(new SubmitCancelProMembershipSurvey(data))
        .then(r => {
            submitSurveySuccessful.value = true;
        })
        .catch(e => {
            surveyResponseStatus.value = e.responseStatus;
        });

    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!cancelled.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "max-w-6xl px-6 mx-auto lg:px-8" }, [
                _createElementVNode("div", { class: "max-w-2xl mx-auto lg:text-center" }, [
                  _createElementVNode("h2", { class: "text-base font-semibold leading-7 sr-only text-clay-600" }, "Cancel Membership"),
                  _createElementVNode("p", { class: "mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl" }, "Are you sure you want to cancel?"),
                  _createElementVNode("p", { class: "mt-6 text-lg leading-8 text-gray-600" }, "Your subscription includes access to these great theatre resources")
                ]),
                _createElementVNode("div", { class: "grid grid-cols-1 gap-4 mt-4 lg:grid-cols-6 lg:grid-rows-1" }, [
                  _createElementVNode("div", { class: "relative flex flex-col overflow-hidden bg-white rounded-lg shadow-xs max-lg:rounded-t-4xl lg:col-span-2 lg:rounded-tl-4xl group ring-1 ring-black/5 data-dark:bg-gray-800 data-dark:ring-white/15" }, [
                    _createElementVNode("div", { class: "relative px-6 py-10" }, [
                      _createElementVNode("div", { class: "flow-root min-h-full px-6 pb-8 rounded-lg bg-white" }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", null, [
                            _createElementVNode("span", { class: "" }, [
                              _createElementVNode("div", { class: "mx-auto mb-4 text-center" }, [
                                _createElementVNode("svg", {
                                  id: "fi_6226141",
                                  "enable-background": "new 0 0 464 464",
                                  height: "72",
                                  viewBox: "0 0 464 464",
                                  width: "72",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }, [
                                  _createElementVNode("path", {
                                    d: "m414.955 0h-320c-8.84 0-16 7.16-16 16v432c0 8.84 7.16 16 16 16h320c8.84 0 16-7.16 16-16v-432c0-8.84-7.16-16-16-16z",
                                    fill: "#ff6d7a"
                                  }),
                                  _createElementVNode("path", {
                                    d: "m415.039 20h-250.084c-8.837 0-16 7.163-16 16v420c0 4.418-3.582 8-8 8h-46c-8.837 0-16-7.163-16-16v-432c0-8.837 7.163-16 16-16h320c13.924 0 13.007 20 .084 20z",
                                    fill: "#ff8c95"
                                  }),
                                  _createElementVNode("path", {
                                    d: "m124.955 361c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-9.03-9.39-18.75-30-18.75-40.107 0-39.932 37.5 0 37.5v16c-61.311 0-61.117-69.5 0-69.5 30.2 0 46 17.48 46 34.75z",
                                    fill: "#cbe3fa"
                                  }),
                                  _createElementVNode("path", {
                                    d: "m124.955 234c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-9.03-9.39-18.75-30-18.75-40.107 0-39.932 37.5 0 37.5v16c-61.311 0-61.117-69.5 0-69.5 30.2 0 46 17.48 46 34.75z",
                                    fill: "#cbe3fa"
                                  }),
                                  _createElementVNode("path", {
                                    d: "m124.955 107c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-9.03-9.39-18.75-30-18.75-40.107 0-39.932 37.5 0 37.5v16c-61.343 0-61.079-69.5 0-69.5 30.2 0 46 17.48 46 34.75z",
                                    fill: "#cbe3fa"
                                  }),
                                  _createElementVNode("g", { fill: "#e84857" }, [
                                    _createElementVNode("path", { d: "m384.955 342h-109c-4.418 0-8-3.582-8-8s3.582-8 8-8h109c4.418 0 8 3.582 8 8s-3.582 8-8 8z" }),
                                    _createElementVNode("path", { d: "m226.955 342h-28c-4.418 0-8-3.582-8-8s3.582-8 8-8h28c4.418 0 8 3.582 8 8s-3.581 8-8 8z" }),
                                    _createElementVNode("path", { d: "m384.955 290h-186c-4.418 0-8-3.582-8-8s3.582-8 8-8h186c4.418 0 8 3.582 8 8s-3.582 8-8 8z" }),
                                    _createElementVNode("path", { d: "m356.955 238h-130c-4.418 0-8-3.582-8-8s3.582-8 8-8h130c4.418 0 8 3.582 8 8s-3.582 8-8 8z" }),
                                    _createElementVNode("path", { d: "m154.955 413c-4.418 0-8-3.582-8-8v-346c0-4.418 3.582-8 8-8s8 3.582 8 8v346c0 4.418-3.581 8-8 8z" })
                                  ]),
                                  _createElementVNode("path", {
                                    d: "m323.165 118.54c9.85 1.43 13.78 13.53 6.65 20.47l-10.22 9.97 2.41 14.08c1.68 9.8-8.61 17.27-17.41 12.65l-12.64-6.65-12.64 6.65c-8.8 4.62-19.09-2.85-17.41-12.65l2.41-14.08-10.22-9.97c-7.13-6.94-3.2-19.04 6.65-20.47l14.13-2.05 6.32-12.81c4.4-8.92 17.12-8.92 21.52 0l6.32 12.81z",
                                    fill: "#ffe773"
                                  })
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("h3", { class: "mb-3 text-2xl font-bold tracking-tight text-gray-900" }, " Discover Show Insights "),
                          _createElementVNode("dd", { class: "mt-5 space-y-3 text-lg text-clay-800" }, [
                            _createElementVNode("p", { class: "flex text-left gap-x-3" }, [
                              _createElementVNode("svg", {
                                class: "flex-none w-5 h-6 text-clay-600",
                                viewBox: "0 0 20 20",
                                fill: "currentColor",
                                "aria-hidden": "true"
                              }, [
                                _createElementVNode("path", {
                                  "fill-rule": "evenodd",
                                  d: "M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z",
                                  "clip-rule": "evenodd"
                                })
                              ]),
                              _createTextVNode(" Full access to expert-written show guides ")
                            ]),
                            _createElementVNode("p", { class: "flex text-left gap-x-3" }, [
                              _createElementVNode("svg", {
                                class: "flex-none w-5 h-6 text-clay-600",
                                viewBox: "0 0 20 20",
                                fill: "currentColor",
                                "aria-hidden": "true"
                              }, [
                                _createElementVNode("path", {
                                  "fill-rule": "evenodd",
                                  d: "M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z",
                                  "clip-rule": "evenodd"
                                })
                              ]),
                              _createTextVNode(" Extensive monologue & scene libraries ")
                            ]),
                            _createElementVNode("p", { class: "flex text-left gap-x-3" }, [
                              _createElementVNode("svg", {
                                class: "flex-none w-5 h-6 text-clay-600",
                                viewBox: "0 0 20 20",
                                fill: "currentColor",
                                "aria-hidden": "true"
                              }, [
                                _createElementVNode("path", {
                                  "fill-rule": "evenodd",
                                  d: "M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z",
                                  "clip-rule": "evenodd"
                                })
                              ]),
                              _createTextVNode(" 25,000+ character breakdowns ")
                            ]),
                            _createElementVNode("p", { class: "flex text-left gap-x-3" }, [
                              _createElementVNode("svg", {
                                class: "flex-none w-5 h-6 text-clay-600",
                                viewBox: "0 0 20 20",
                                fill: "currentColor",
                                "aria-hidden": "true"
                              }, [
                                _createElementVNode("path", {
                                  "fill-rule": "evenodd",
                                  d: "M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z",
                                  "clip-rule": "evenodd"
                                })
                              ]),
                              _createTextVNode(" Song vocal notes ")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", { class: "relative flex flex-col overflow-hidden bg-white rounded-lg shadow-xs max-lg:rounded-t-4xl lg:col-span-2 lg:rounded-lg group ring-1 ring-black/5 data-dark:bg-gray-800 data-dark:ring-white/15" }, [
                    _createElementVNode("div", { class: "relative px-6 py-10" }, [
                      _createElementVNode("div", { class: "" }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", { class: "inline-flex items-center justify-center rounded-md" }, [
                            _createElementVNode("div", { class: "mb-4" }, [
                              _createElementVNode("svg", {
                                id: "fi_2281284",
                                "enable-background": "new 0 0 512 512",
                                height: "72",
                                viewBox: "0 0 512 512",
                                width: "72",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("g", null, [
                                  _createElementVNode("path", {
                                    d: "m129.224 370.659-8.633 47.646s-5.336 1.586-11.857 2.421c-7.397.938-16.318.907-20.738-3.513-8.324-8.324 0-29.69 0-29.69l11.775-4.821z",
                                    fill: "#ffcbbe"
                                  }),
                                  _createElementVNode("path", {
                                    d: "m108.733 420.726c-7.397.938-16.318.907-20.738-3.513-8.324-8.324 0-29.69 0-29.69l11.775-4.821 7.407 4.821c.001 0-12.588 21.232 1.556 33.203z",
                                    fill: "#eaac9d"
                                  }),
                                  _createElementVNode("path", {
                                    d: "m357.913 283.228c-2.73 4.121-5.532 7.84-8.386 11.198-42.371 49.768-97.053 19.986-98.228 19.337h-.01c.381.618 15.288 24.704 18.533 56.897l1.35 16.864s5.12 58.38-11.26 100.371h-51.2s12.836-59.524-12.609-84.969c-25.445 25.445-12.609 84.969-12.609 84.969h-51.2c-16.38-41.99-11.26-100.371-11.26-100.371h-33.038c0-92.366 37.499-122.88 43.999-127.475h128.216c13.547 40.744 72.535 11.095 72.535 11.095z",
                                    fill: "#da4a54"
                                  }),
                                  _createElementVNode("path", {
                                    d: "m349.528 294.426c-42.371 49.768-97.053 19.986-98.228 19.337h-.01l-.01-.01-2.147-7.433c-1.352-4.68 3.203-8.903 7.762-7.188 17.358 6.531 52.753 14.783 92.633-4.706z",
                                    fill: "#c32430"
                                  }),
                                  _createElementVNode("path", {
                                    d: "m236.711 258.407c.024.359.032.719.032 1.078 0 16.296-18.197 29.508-40.644 29.508s-40.644-13.212-40.644-29.508c0-.359.008-.719.032-1.078",
                                    fill: "#eaac9d"
                                  }),
                                  _createElementVNode("path", {
                                    d: "m259.914 487.888-3.687 7.456-47.513-7.456s12.831-59.514-12.615-84.97c-25.446 25.456-12.605 84.97-12.605 84.97h-51.2c-16.382-41.982-11.26-100.367-11.26-100.367 0-5.779.544-11.527 1.345-16.865h147.451l1.345 16.865c-.001 0 5.121 58.385-11.261 100.367z",
                                    fill: "#756e78"
                                  }),
                                  _createElementVNode("path", {
                                    d: "m149.516 260.045c-15.264 20.601-43.07 66.597-42.341 127.476h-19.185c0-92.371 37.507-122.877 44.004-127.476z",
                                    fill: "#c32430"
                                  }),
                                  _createElementVNode("path", {
                                    d: "m147.443 487.888-9.355 12.056-5.806-12.056c-16.382-41.982-11.26-100.367-11.26-100.367 0-5.779.544-11.527 1.345-16.865h24.296c-5.153 19.277-11.528 59.299.78 117.232z",
                                    fill: "#544f57"
                                  }),
                                  _createElementVNode("path", {
                                    d: "m222.066 487.888h-13.365s12.841-59.514-12.605-84.97c25.97 0 39.324 44.713 25.97 84.97z",
                                    fill: "#544f57"
                                  }),
                                  _createElementVNode("path", {
                                    d: "m313.263 143.239-157.795.676-78.357.33c-5.973-54.54-23.311-125.368 40.387-137.991 15.293-3.033 29.065-4.833 41.443-5.678 82.911-5.627 103.535 31.811 103.535 31.811s15.006-13.181 31.321-11.837c5.897.482 11.972 2.873 17.566 8.466 29.503 29.504 1.9 114.223 1.9 114.223z",
                                    fill: "#aa593d"
                                  }),
                                  _createElementVNode("path", {
                                    d: "m293.796 20.55c-19.382 13.316-32.064 53.161-37.936 75.873-5.745-23.134 1.276-48.599 6.616-64.035-.001-.001 15.005-13.182 31.32-11.838z",
                                    fill: "#934d36"
                                  }),
                                  _createElementVNode("path", {
                                    d: "m146.732 85.134 8.736 58.78-78.357.33c-5.973-54.539-23.311-125.367 40.387-137.99 15.293-3.033 29.065-4.833 41.443-5.678 0 .008-.008.008-.008.008-31.896 19.619-22.045 54.565-12.201 84.55z",
                                    fill: "#934d36"
                                  }),
                                  _createElementVNode("path", {
                                    d: "m302.821 187.303h.149c12.833 0 23.232-10.407 23.232-23.232 0-12.833-10.399-23.241-23.232-23.241-.167 0-.334 0-.501.009h-212.735c-.167-.009-.334-.009-.501-.009-12.833 0-23.232 10.407-23.232 23.241 0 12.825 10.399 23.232 23.232 23.232h.149",
                                    fill: "#eaac9d"
                                  }),
                                  _createElementVNode("path", {
                                    d: "m303.048 169.515c0 12.234-.313 24.477-.938 36.711-1.563 30.586-26.04 54.936-56.642 56.381-21.393 1.014-42.794 1.36-64.188 1.056h-.008c-11.516-.161-23.024-.515-34.54-1.056-30.594-1.445-55.071-25.795-56.643-56.381-1.115-21.799-1.234-43.589-.363-65.387h.008c11.93-4.419 19.027-18.157 23.243-33.433 4.326-15.673 19.34-24.24 33.754-22.272 5.619.769 11.153 3.143 15.918 7.317 9.573 8.381 21.511 12.572 33.45 12.572s23.885-4.191 33.458-12.572c5.931-5.196 13.037-7.596 20.033-7.596 13.054 0 25.719 8.365 29.639 22.551 4.208 15.276 11.305 29.014 23.243 33.433.39 9.564.576 19.12.576 28.676z",
                                    fill: "#ffcbbe"
                                  }),
                                  _createElementVNode("path", {
                                    d: "m181.271 263.663c-11.516-.161-23.024-.515-34.54-1.056-30.594-1.445-55.071-25.795-56.643-56.381-1.115-21.799-1.234-43.589-.363-65.387h.008c11.93-4.419 19.027-18.157 23.243-33.433 4.326-15.673 19.34-24.24 33.754-22.272-10.94 97.697.002 177.456 34.541 178.529z",
                                    fill: "#eaac9d"
                                  }),
                                  _createElementVNode("g", { fill: "#544f57" }, [
                                    _createElementVNode("path", { d: "m146.634 141.477c-5.353 0-9.708 6.475-9.708 14.433s4.355 14.433 9.708 14.433 9.708-6.475 9.708-14.433-4.355-14.433-9.708-14.433z" }),
                                    _createElementVNode("path", { d: "m245.57 141.477c-5.353 0-9.708 6.475-9.708 14.433s4.355 14.433 9.708 14.433 9.708-6.475 9.708-14.433-4.354-14.433-9.708-14.433z" })
                                  ]),
                                  _createElementVNode("path", {
                                    d: "m116.933 512h66.561v-24.108h-42.454c-13.313 0-24.107 10.794-24.107 24.108z",
                                    fill: "#aa593d"
                                  }),
                                  _createElementVNode("path", {
                                    d: "m156.411 487.888c-13.313 0-24.112 10.798-24.112 24.112h-15.366c0-13.313 10.788-24.112 24.101-24.112z",
                                    fill: "#934d36"
                                  }),
                                  _createElementVNode("path", {
                                    d: "m275.271 512h-66.561v-24.108h42.453c13.314 0 24.108 10.794 24.108 24.108z",
                                    fill: "#aa593d"
                                  }),
                                  _createElementVNode("path", {
                                    d: "m196.1 218.768c-12.21 0-23.482-7.129-28.718-18.161-1.829-3.855-.187-8.463 3.668-10.293 3.856-1.83 8.463-.187 10.293 3.668 2.691 5.67 8.483 9.334 14.757 9.334s12.067-3.664 14.758-9.334c1.829-3.855 6.439-5.498 10.293-3.668 3.855 1.829 5.497 6.438 3.668 10.293-5.237 11.032-16.51 18.161-28.719 18.161z",
                                    fill: "#da4a54"
                                  }),
                                  _createElementVNode("g", null, [
                                    _createElementVNode("path", {
                                      d: "m445.999 59.105h-176.17v91.409c0 42.849 27.125 81.001 67.596 95.076l20.489 7.126 20.489-7.126c40.471-14.075 67.596-52.227 67.596-95.076z",
                                      fill: "#9dc6fb"
                                    }),
                                    _createElementVNode("path", {
                                      d: "m357.914 252.715-20.49-7.119c-40.465-14.083-67.59-52.23-67.59-95.075v-91.407h42.959v91.408c0 42.845 13.897 80.993 34.624 95.075z",
                                      fill: "#7398d3"
                                    }),
                                    _createElementVNode("g", { fill: "#fff" }, [
                                      _createElementVNode("g", null, [
                                        _createElementVNode("path", { d: "m344.125 145.685c-4.267 0-7.726-3.459-7.726-7.726 0-8.324-6.772-15.096-15.096-15.096s-15.096 6.772-15.096 15.096c0 4.267-3.459 7.726-7.726 7.726s-7.726-3.459-7.726-7.726c0-16.845 13.704-30.549 30.549-30.549s30.549 13.704 30.549 30.549c-.002 4.267-3.461 7.726-7.728 7.726z" }),
                                        _createElementVNode("path", { d: "m417.348 145.685c-4.267 0-7.726-3.459-7.726-7.726 0-8.324-6.772-15.096-15.096-15.096s-15.096 6.772-15.096 15.096c0 4.267-3.459 7.726-7.726 7.726s-7.726-3.459-7.726-7.726c0-16.845 13.704-30.549 30.549-30.549s30.549 13.704 30.549 30.549c-.002 4.267-3.461 7.726-7.728 7.726z" })
                                      ]),
                                      _createElementVNode("path", { d: "m357.913 197.486c-12.206 0-24.412-4.646-33.704-13.939-3.018-3.017-3.018-7.909 0-10.927 3.017-3.018 7.909-3.018 10.927 0 12.561 12.56 32.996 12.559 45.556 0 3.017-3.018 7.909-3.018 10.927 0 3.018 3.017 3.018 7.909 0 10.927-9.293 9.293-21.499 13.939-33.706 13.939z" })
                                    ])
                                  ]),
                                  _createElementVNode("path", {
                                    d: "m357.913 283.228-13.784-6.614-11.384-5.47c-3.163-14.598 11.064-49.614 29.092-36.901v.01c1.03.721 2.081 1.607 3.132 2.658 19.472 19.47-7.056 46.317-7.056 46.317z",
                                    fill: "#ffcbbe"
                                  }),
                                  _createElementVNode("path", {
                                    d: "m361.838 234.243v.01s-22.118 20.964-17.709 42.361l-11.384-5.47c-3.162-14.598 11.065-49.614 29.093-36.901z",
                                    fill: "#eaac9d"
                                  }),
                                  _createElementVNode("path", {
                                    d: "m122.366 370.657c2.525-23.21 21.32-63.933 21.32-63.933s-11.053 54.923 2.976 63.933",
                                    fill: "#c32430"
                                  }),
                                  _createElementVNode("path", {
                                    d: "m208.71 487.888h13.357v24.112h-13.357z",
                                    fill: "#934d36"
                                  })
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("h3", { class: "mb-3 text-2xl font-bold tracking-tight text-gray-900" }, "Improve Your Craft"),
                        _createElementVNode("dd", { class: "mt-5 space-y-3 text-lg text-clay-800" }, [
                          _createElementVNode("p", { class: "flex text-left gap-x-3" }, [
                            _createElementVNode("svg", {
                              class: "flex-none w-5 h-6 text-clay-600",
                              viewBox: "0 0 20 20",
                              fill: "currentColor",
                              "aria-hidden": "true"
                            }, [
                              _createElementVNode("path", {
                                "fill-rule": "evenodd",
                                d: "M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z",
                                "clip-rule": "evenodd"
                              })
                            ]),
                            _createTextVNode(" Learning modules to expand your skills ")
                          ]),
                          _createElementVNode("p", { class: "flex text-left gap-x-3" }, [
                            _createElementVNode("svg", {
                              class: "flex-none w-5 h-6 text-clay-600",
                              viewBox: "0 0 20 20",
                              fill: "currentColor",
                              "aria-hidden": "true"
                            }, [
                              _createElementVNode("path", {
                                "fill-rule": "evenodd",
                                d: "M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z",
                                "clip-rule": "evenodd"
                              })
                            ]),
                            _createTextVNode(" Suggested audition pieces ")
                          ]),
                          _createElementVNode("p", { class: "flex text-left gap-x-3" }, [
                            _createElementVNode("svg", {
                              class: "flex-none w-5 h-6 text-clay-600",
                              viewBox: "0 0 20 20",
                              fill: "currentColor",
                              "aria-hidden": "true"
                            }, [
                              _createElementVNode("path", {
                                "fill-rule": "evenodd",
                                d: "M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z",
                                "clip-rule": "evenodd"
                              })
                            ]),
                            _createTextVNode(" Downloadable theatre templates ")
                          ]),
                          _createElementVNode("p", { class: "flex text-left gap-x-3" }, [
                            _createElementVNode("svg", {
                              class: "flex-none w-5 h-6 text-clay-600",
                              viewBox: "0 0 20 20",
                              fill: "currentColor",
                              "aria-hidden": "true"
                            }, [
                              _createElementVNode("path", {
                                "fill-rule": "evenodd",
                                d: "M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z",
                                "clip-rule": "evenodd"
                              })
                            ]),
                            _createTextVNode(" Exclusive blog content ")
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", { class: "relative flex flex-col overflow-hidden bg-white rounded-lg shadow-xs lg:col-span-2 lg:rounded-tr-4xl group ring-1 ring-black/5 data-dark:bg-gray-800 data-dark:ring-white/15" }, [
                    _createElementVNode("div", { class: "relative px-6 py-10" }, [
                      _createElementVNode("div", { class: "" }, [
                        _createElementVNode("div", { class: "flow-root min-h-full px-6 pb-8 rounded-lg bg-white" }, [
                          _createElementVNode("div", { class: "" }, [
                            _createElementVNode("div", null, [
                              _createElementVNode("span", { class: "inline-flex items-center justify-center rounded-md" }, [
                                _createElementVNode("div", { class: "mb-4" }, [
                                  _createElementVNode("svg", {
                                    "clip-rule": "evenodd",
                                    "fill-rule": "evenodd",
                                    height: "72",
                                    "image-rendering": "optimizeQuality",
                                    "shape-rendering": "geometricPrecision",
                                    "text-rendering": "geometricPrecision",
                                    viewBox: "0 0 1707 1707",
                                    width: "72",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    id: "fi_8437994"
                                  }, [
                                    _createElementVNode("g", { id: "Layer_x0020_1" }, [
                                      _createElementVNode("g", { id: "_592637808" }, [
                                        _createElementVNode("path", {
                                          d: "m792 342v286c0 31-25 56-55 56h-192l-161 94 20-94c-30 0-55-25-55-56v-231c0-30 25-55 55-55z",
                                          fill: "#58b78c"
                                        }),
                                        _createElementVNode("path", {
                                          d: "m1265 577c51 0 93-42 93-94v-390c0-51-42-93-93-93h-561c-52 0-94 42-94 93v390c0 52 42 94 94 94h371l223 159z",
                                          fill: "#f2c42c"
                                        }),
                                        _createElementVNode("path", {
                                          d: "m368 1378c181 0 328 147 328 329h-657c0-182 147-329 329-329z",
                                          fill: "#0da9ff"
                                        }),
                                        _createElementVNode("g", { fill: "#1696eb" }, [
                                          _createElementVNode("path", { d: "m560 1707h-84v-140c0-23 19-42 42-42 24 0 42 19 42 42z" }),
                                          _createElementVNode("path", { d: "m259 1707h-84v-140c0-23 19-42 42-42 24 0 42 19 42 42z" })
                                        ]),
                                        _createElementVNode("g", { "fill-rule": "nonzero" }, [
                                          _createElementVNode("circle", {
                                            cx: "368",
                                            cy: "1126",
                                            fill: "#fdba91",
                                            r: "176"
                                          }),
                                          _createElementVNode("path", {
                                            d: "m1291 1330c208 0 376 169 376 377h-753c0-208 169-377 377-377z",
                                            fill: "#ef4b3f"
                                          }),
                                          _createElementVNode("g", { fill: "#ee3c39" }, [
                                            _createElementVNode("path", { d: "m1505 1707h-84v-160c0-23 19-42 42-42s42 19 42 42z" }),
                                            _createElementVNode("path", { d: "m1160 1707h-84v-160c0-23 19-42 42-42s42 19 42 42z" })
                                          ]),
                                          _createElementVNode("circle", {
                                            cx: "1291",
                                            cy: "1041",
                                            fill: "#fdba91",
                                            r: "202"
                                          })
                                        ]),
                                        _createElementVNode("path", {
                                          d: "m781 244c-24 0-42-19-42-42s18-42 42-42h407c23 0 42 19 42 42s-19 42-42 42z",
                                          fill: "#f29130"
                                        }),
                                        _createElementVNode("path", {
                                          d: "m781 417c-24 0-42-19-42-42s18-42 42-42h407c23 0 42 19 42 42s-19 42-42 42z",
                                          fill: "#f29130"
                                        })
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("h3", { class: "mb-3 text-2xl font-bold tracking-tight text-gray-900" }, "Engage the Community"),
                            _createElementVNode("dd", { class: "mt-5 space-y-3 text-lg text-clay-800" }, [
                              _createElementVNode("p", { class: "flex text-left gap-x-3" }, [
                                _createElementVNode("svg", {
                                  class: "flex-none w-5 h-6 text-clay-600",
                                  viewBox: "0 0 20 20",
                                  fill: "currentColor",
                                  "aria-hidden": "true"
                                }, [
                                  _createElementVNode("path", {
                                    "fill-rule": "evenodd",
                                    d: "M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z",
                                    "clip-rule": "evenodd"
                                  })
                                ]),
                                _createTextVNode(" Showcase auditions and classes ")
                              ]),
                              _createElementVNode("p", { class: "flex text-left gap-x-3" }, [
                                _createElementVNode("svg", {
                                  class: "flex-none w-5 h-6 text-clay-600",
                                  viewBox: "0 0 20 20",
                                  fill: "currentColor",
                                  "aria-hidden": "true"
                                }, [
                                  _createElementVNode("path", {
                                    "fill-rule": "evenodd",
                                    d: "M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z",
                                    "clip-rule": "evenodd"
                                  })
                                ]),
                                _createTextVNode(" Promote shows and events ")
                              ]),
                              _createElementVNode("p", { class: "flex text-left gap-x-3" }, [
                                _createElementVNode("svg", {
                                  class: "flex-none w-5 h-6 text-clay-600",
                                  viewBox: "0 0 20 20",
                                  fill: "currentColor",
                                  "aria-hidden": "true"
                                }, [
                                  _createElementVNode("path", {
                                    "fill-rule": "evenodd",
                                    d: "M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z",
                                    "clip-rule": "evenodd"
                                  })
                                ]),
                                _createTextVNode(" Find and contact talent for productions ")
                              ]),
                              _createElementVNode("p", { class: "flex text-left gap-x-3" }, [
                                _createElementVNode("svg", {
                                  class: "flex-none w-5 h-6 text-clay-600",
                                  viewBox: "0 0 20 20",
                                  fill: "currentColor",
                                  "aria-hidden": "true"
                                }, [
                                  _createElementVNode("path", {
                                    "fill-rule": "evenodd",
                                    d: "M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z",
                                    "clip-rule": "evenodd"
                                  })
                                ]),
                                _createTextVNode(" Feature your profile with enhanced tools ")
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "mt-8" }, [
                  _createElementVNode("div", { class: "px-3 mt-5 space-y-3 text-lg text-clay-800" }, [
                    _createElementVNode("p", { class: "text-xl font-medium tracking-tight text-gray-900" }, " Additional Premium Benefits "),
                    _createElementVNode("ul", {
                      role: "list",
                      class: "grid grid-cols-1 gap-5 mt-8 sm:grid-cols-2 sm:gap-6 lg:grid-cols-2"
                    }, [
                      _createElementVNode("li", { class: "flex col-span-1 py-2 border rounded-md shadow-sm border-clay-500 bg-clay-50 min-h-16" }, [
                        _createElementVNode("div", { class: "flex items-center justify-center w-16 text-sm font-medium text-white shrink-0 rounded-l-md" }, [
                          _createElementVNode("svg", {
                            id: "fi_3370181",
                            "enable-background": "new 0 0 480.04 480.04",
                            height: "38",
                            viewBox: "0 0 480.04 480.04",
                            width: "38",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("path", {
                              d: "m274.02 24v363h-226c-8.837 0-16-7.163-16-16v-347c0-8.837 7.163-16 16-16h210c8.837 0 16 7.163 16 16z",
                              fill: "#e8f3ff"
                            }),
                            _createElementVNode("path", {
                              d: "m448.02 109v347c0 8.84-7.16 16-16 16h-226v-85h-158c-8.84 0-16-7.16-16-16v-77.83c0-7.94 5.84-14.66 13.7-15.82 126.44-18.7 195.67-131.49 172.56-250.24-1.92-9.9 5.6-19.11 15.69-19.11h24.05c8.84 0 16 7.16 16 16v69h158c8.84 0 16 7.16 16 16z",
                              fill: "#d1e7ff"
                            }),
                            _createElementVNode("path", {
                              d: "m274.02 387-68 85v-85z",
                              fill: "#a2d0ff"
                            }),
                            _createElementVNode("path", {
                              d: "m210.02 77v98c0 4.418-3.582 8-8 8h-98c-4.418 0-8-3.582-8-8v-98c0-4.418 3.582-8 8-8h98c4.418 0 8 3.582 8 8z",
                              fill: "#d1e7ff"
                            }),
                            _createElementVNode("path", {
                              d: "m301.5 101c0 312.946.838 294.693-1.753 297.931l-56.055 70.066c-1.518 1.898-3.817 3.002-6.247 3.002h-31.425c6.915-8.644 59.401-74.251 68-85v-293.999h19.48c4.418 0 8 3.582 8 8z",
                              fill: "#b9dcff"
                            }),
                            _createElementVNode("path", {
                              d: "m456.02 93v379c0 4.418-3.582 8-8 8-258.488 0-242.847.264-244.944-.566-3.13-1.243-5.056-4.267-5.056-7.434v-37.839c0-4.418 3.582-8 8-8s8 3.582 8 8v15.032l52-65v-368.193h-226v363h166c4.418 0 8 3.582 8 8s-3.582 8-8 8h-174c-4.418 0-8-3.582-8-8v-379c0-4.418 3.582-8 8-8h242c4.418 0 8 3.582 8 8v379c0 4.015 2.853-.759-59.355 77h217.355v-363h-121c-4.418 0-8-3.582-8-8s3.582-8 8-8h129c4.418 0 8 3.582 8 8zm-368 90v-114c0-4.418 3.582-8 8-8h114c4.418 0 8 3.582 8 8v114c0 4.418-3.582 8-8 8h-114c-4.418 0-8-3.582-8-8zm16-8h98v-98h-98zm114 78c0-4.418-3.582-8-8-8h-114c-4.418 0-8 3.582-8 8s3.582 8 8 8h114c4.418 0 8-3.582 8-8zm-24.94 48.61c-4.602-1.921-9.929.858-10.899 5.83-1.301 6.011 4.86 11.466 10.899 8.95 6.512-2.714 6.631-12.017 0-14.78zm-77.06-.61c-4.418 0-8 3.582-8 8s3.582 8 8 8h37c4.418 0 8-3.582 8-8s-3.582-8-8-8zm203-90h71c4.418 0 8-3.582 8-8s-3.582-8-8-8h-71c-4.418 0-8 3.582-8 8s3.582 8 8 8zm0 80h71c4.418 0 8-3.582 8-8s-3.582-8-8-8h-71c-4.418 0-8 3.582-8 8s3.582 8 8 8zm55 64c-4.418 0-8 3.582-8 8s3.582 8 8 8h1c4.418 0 8-3.582 8-8s-3.582-8-8-8zm-55 16h21c4.418 0 8-3.582 8-8s-3.582-8-8-8h-21c-4.418 0-8 3.582-8 8s3.582 8 8 8z",
                              fill: "#2e58ff"
                            })
                          ])
                        ]),
                        _createElementVNode("div", { class: "flex items-center justify-between flex-1 rounded-r-md" }, [
                          _createElementVNode("div", { class: "flex-1 p-4 py-2 text-sm md:pr-4 md:py-4 md:pl-0" }, [
                            _createElementVNode("p", { class: "font-medium text-clay-600" }, "Banner ad-free experience")
                          ])
                        ])
                      ]),
                      _createElementVNode("li", { class: "flex col-span-1 py-2 border rounded-md shadow-sm border-clay-500 bg-clay-50 min-h-16" }, [
                        _createElementVNode("div", { class: "flex items-center justify-center w-16 text-sm font-medium text-white shrink-0 rounded-l-md" }, [
                          _createElementVNode("svg", {
                            id: "fi_3652030",
                            "enable-background": "new 0 0 480.101 480.101",
                            height: "38",
                            viewBox: "0 0 480.101 480.101",
                            width: "38",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("path", {
                              d: "m465.16 361.714c9.24 9.24 9.24 24.22 0 33.47-9.21 9.21-24.19 9.26-33.46 0l-52.65-52.65c-9.24-9.24-9.24-24.23 0-33.47 9.22-9.21 24.2-9.26 33.46 0z",
                              fill: "#b9dcff"
                            }),
                            _createElementVNode("path", {
                              d: "m446.577 381.063c9.2 9.297-4.169 23.751-13.916 15.03-.733-.656 2.794 2.847-53.611-53.559-11.098-11.098-8.496-29.766 5.204-37.404 7.832-4.366 16.803 3.065 14.6 11.757-1.962 7.743-.033 16.45 6.196 22.647 20.87 20.765 33.569 33.488 41.527 41.529z",
                              fill: "#d1e7ff"
                            }),
                            _createElementVNode("circle", {
                              cx: "269",
                              cy: "198.984",
                              fill: "#e8f3ff",
                              r: "121"
                            }),
                            _createElementVNode("path", {
                              d: "m316 137.984h-151.52c-4.23 7.23-7.73 14.93-10.39 23h-130.09c-8.84 0-16 7.16-16 16v44c0 8.84 7.16 16 16 16h130.09c2.66 8.07 6.16 15.77 10.39 23h151.52c13.25 0 24-10.75 24-24v-74c0-13.25-10.75-24-24-24z",
                              fill: "#d1e7ff"
                            }),
                            _createElementVNode("path", {
                              d: "m154.09 160.984c-2.13 6.44-3.73 13.13-4.76 20h-95.33c-8.837 0-16 7.163-16 16v26c0 7.732-6.268 14-14 14-8.837 0-16-7.163-16-16v-44c0-8.837 7.163-16 16-16z",
                              fill: "#e8f3ff"
                            }),
                            _createElementVNode("path", {
                              d: "m154.09 236.984h-18.781c-3.711 0-6.974-2.543-7.787-6.164-4.696-20.91-4.701-42.74 0-63.672.813-3.621 4.076-6.164 7.787-6.164h18.781c-7.942 24.96-8.486 49.329 0 76z",
                              fill: "#b9dcff"
                            }),
                            _createElementVNode("path", {
                              d: "m340 161.984v74c0 13.25-10.75 24-24 24h-111v-122h111c13.25 0 24 10.75 24 24z",
                              fill: "#b9dcff"
                            }),
                            _createElementVNode("g", { fill: "#2e58ff" }, [
                              _createElementVNode("path", { d: "m470.82 356.059-52.649-52.65c-3.123-3.122-8.188-3.123-11.314 0-3.124 3.124-3.124 8.189 0 11.314l52.65 52.65c9.857 9.857 2.796 26.72-11.064 26.736-4.071.005-8.043-1.545-11.085-4.588l-52.65-52.648c-6.106-6.107-6.106-16.044.001-22.15 3.117-3.117 3.131-8.182 0-11.314l-19.072-19.071c20.126-22.761 32.363-52.653 32.363-85.354 0-71.131-57.869-129-129-129-54.933 0-101.948 34.519-120.515 83h-124.485c-13.234 0-24 10.767-24 24v44c0 13.233 10.766 24 24 24h89.516c4.418 0 8-3.582 8-8s-3.582-8-8-8h-89.516c-4.411 0-8-3.589-8-8v-44c0-4.411 3.589-8 8-8h119.53c-7.648 31.991-2.831 66.112 14.043 95.039 1.209 2.086 3.477 3.684 6.228 3.927.607.053-8.882.034 152.199.034 17.645 0 32-14.355 32-32v-74c0-17.645-14.355-32-32-32h-111c-4.418 0-8 3.582-8 8v78.807c0 4.418 3.582 8 8 8s8-3.582 8-8v-70.807h103c8.822 0 16 7.178 16 16v74c0 8.822-7.178 16-16 16h-146.814c-8.633-16.24-13.186-34.464-13.186-53 0-62.309 50.691-113 113-113s113 50.691 113 113-50.691 113-113 113c-24.101 0-47.098-7.48-66.506-21.634-3.57-2.603-8.574-1.82-11.178 1.75-2.603 3.57-1.82 8.574 1.75 11.178 48.019 35.018 115.142 33.119 161.253-7.628l14.142 14.142c-7.102 12.128-5.459 28.004 4.931 38.396l52.65 52.648c12.392 12.394 32.423 12.355 44.776.001 12.376-12.375 12.377-32.401.002-44.778z" }),
                              _createElementVNode("path", { d: "m267.5 163.984c-18.472 0-33.5 15.028-33.5 33.5 0 26.179 28.809 42.159 50.958 28.579l8.353 8.353c3.126 3.124 8.189 3.123 11.314 0 3.124-3.125 3.124-8.189 0-11.314l-8.401-8.4c13.378-22.237-2.747-50.718-28.724-50.718zm-17.5 33.5c0-9.649 7.851-17.5 17.5-17.5s17.5 7.851 17.5 17.5-7.851 17.5-17.5 17.5-17.5-7.85-17.5-17.5z" })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", { class: "flex items-center justify-between flex-1 rounded-r-md" }, [
                          _createElementVNode("div", { class: "flex-1 p-4 py-2 text-sm md:pr-4 md:py-4 md:pl-0" }, [
                            _createElementVNode("p", { class: "font-medium text-clay-600" }, "Advanced search filters")
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, [
                  _cache[2] || (_cache[2] = _createTextVNode("By canceling, you will lose access to these theatre resources on ")),
                  _createElementVNode("em", null, _toDisplayString(_unref(membershipEndsOn)), 1),
                  _cache[3] || (_cache[3] = _createTextVNode(". "))
                ]),
                _createElementVNode("a", {
                  class: "inline-flex justify-center px-5 py-2 text-lg font-medium text-white border border-transparent rounded-md shadow-sm bg-clay-950 hover:border hover:bg-clay-900 hover:outline-hidden hover:ring-2 hover:ring-offset-2 focus:ring-clay-900 text-md",
                  href: "#",
                  onClick: _withModifiers(showConfirmation, ["prevent"])
                }, "Cancel subscription"),
                _cache[4] || (_cache[4] = _createElementVNode("a", {
                  class: "inline-flex justify-center px-5 py-2 text-lg font-medium text-gray-600 underline hover:no-underline text-md",
                  href: "/membership"
                }, "Keep subscription ", -1))
              ])
            ]),
            _createVNode(_unref(TransitionRoot), {
              show: isOpen.value,
              as: "template"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Dialog), {
                  as: "div",
                  class: "relative z-10",
                  onClose: closeConfirmation
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(TransitionChild), {
                      as: "template",
                      enter: "ease-out duration-300",
                      "enter-from": "opacity-0",
                      "enter-to": "opacity-100",
                      leave: "ease-in duration-200",
                      "leave-from": "opacity-100",
                      "leave-to": "opacity-0"
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createElementVNode("div", { class: "fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" }, null, -1)
                      ])),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_unref(DialogPanel), { class: "relative px-4 pt-5 pb-4 overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:max-w-lg sm:w-full sm:p-6" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", { class: "absolute top-0 right-0 hidden pt-4 pr-4 sm:block" }, [
                              _createElementVNode("button", {
                                class: "text-gray-400 bg-white rounded-md hover:text-gray-600 focus:outline-hidden",
                                type: "button",
                                onClick: closeConfirmation
                              }, _cache[7] || (_cache[7] = [
                                _createElementVNode("span", { class: "sr-only" }, "Close", -1),
                                _createElementVNode("svg", {
                                  class: "w-6 h-6",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "1.5",
                                  viewBox: "0 0 24 24",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }, [
                                  _createElementVNode("path", {
                                    d: "M6 18L18 6M6 6l12 12",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  })
                                ], -1)
                              ]))
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_9, [
                                _createVNode(_unref(FlagIcon), {
                                  "aria-hidden": "true",
                                  class: "w-6 h-6 text-red-600"
                                })
                              ]),
                              _createElementVNode("div", _hoisted_10, [
                                _createVNode(_unref(DialogTitle), {
                                  as: "h3",
                                  class: "text-lg font-medium leading-6 text-center text-gray-900"
                                }, {
                                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                                    _createTextVNode(" Confirm cancellation ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(ErrorSummary, {
                                  "response-status": cancellationResponseStatus.value,
                                  class: "mt-2"
                                }, null, 8, ["response-status"]),
                                _createElementVNode("div", _hoisted_11, [
                                  _createElementVNode("p", null, [
                                    _cache[9] || (_cache[9] = _createTextVNode("By clicking \"Cancel subscription\" below, you will lose access to your pro access on ")),
                                    _createElementVNode("em", null, _toDisplayString(_unref(membershipEndsOn)), 1),
                                    _cache[10] || (_cache[10] = _createTextVNode("."))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                  _cache[13] || (_cache[13] = _createElementVNode("a", {
                                    class: "inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-clay-500 rounded-md shadow-sm hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-slate-700 focus:ring-offset-2 sm:col-start-1 sm:mt-0 sm:text-sm",
                                    href: "/membership"
                                  }, " Keep subscription ", -1)),
                                  _createVNode(SaButton, {
                                    onClick: _withModifiers(cancelSubscription, ["prevent"]),
                                    loading: processing.value,
                                    variant: "primary"
                                  }, {
                                    loading: _withCtx(() => _cache[11] || (_cache[11] = [
                                      _createTextVNode(" Cancelling... ")
                                    ])),
                                    default: _withCtx(() => [
                                      _cache[12] || (_cache[12] = _createTextVNode(" Cancel subscription "))
                                    ]),
                                    _: 1
                                  }, 8, ["loading"])
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["show"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[17] || (_cache[17] = _createElementVNode("div", {
                  class: "absolute inset-x-0 overflow-hidden -top-40 -z-10 transform-gpu blur-3xl sm:-top-80",
                  "aria-hidden": "true"
                }, [
                  _createElementVNode("div", {
                    class: "relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#4c819c] to-[#1f13c3] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]",
                    style: {"clip-path":"polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"}
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _cache[16] || (_cache[16] = _createElementVNode("h1", { class: "text-4xl font-bold tracking-tight sm:text-4xl font-display text-clay-950" }, " You've successfully canceled", -1)),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("p", _hoisted_19, [
                        _createTextVNode("Your subscription ends on " + _toDisplayString(_unref(membershipEndsOn)) + " and you’ll no longer be charged. We've sent a confirmation email to ", 1),
                        _createElementVNode("em", null, _toDisplayString(props.email), 1),
                        _cache[14] || (_cache[14] = _createTextVNode(". "))
                      ]),
                      _cache[15] || (_cache[15] = _createElementVNode("p", { class: "font-semibold text-clay-800" }, [
                        _createTextVNode("Canceled by mistake? "),
                        _createElementVNode("a", {
                          href: "/membership",
                          class: "underline"
                        }, "Resume subscription")
                      ], -1))
                    ])
                  ])
                ]),
                _cache[18] || (_cache[18] = _createElementVNode("div", {
                  class: "absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]",
                  "aria-hidden": "true"
                }, [
                  _createElementVNode("div", {
                    class: "relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#4c819c] to-[#1f13c3] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]",
                    style: {"clip-path":"polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"}
                  })
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("section", _hoisted_22, [
                  (submitSurveySuccessful.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, _cache[19] || (_cache[19] = [
                        _createStaticVNode("<div class=\"min-w-full mx-auto text-center\"><div class=\"space-y-3\"><h1 class=\"mt-4 mb-5 text-2xl tracking-tight text-slate-600 sm:text-4xl\">Thank you!</h1><p class=\"my-4 text-xl leading-6 text-clay-800\">We have received your feedback. </p></div><a href=\"/\" class=\"inline-flex justify-center px-5 py-2 mt-10 text-lg font-medium text-white border border-transparent rounded-md shadow-sm bg-powder-600 hover:border hover:bg-powder-500 hover:outline-hidden hover:ring-2 hover:ring-offset-2 focus:ring-powder-900 text-md\"> Back to Homepage </a></div>", 1)
                      ])))
                    : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createVNode(ErrorSummary, {
                          "response-status": surveyResponseStatus.value,
                          class: "mt-2"
                        }, null, 8, ["response-status"]),
                        _cache[21] || (_cache[21] = _createElementVNode("p", { class: "mx-auto mt-5 text-2xl font-medium text-center text-clay-800" }, "Your feedback helps us improve", -1)),
                        _cache[22] || (_cache[22] = _createElementVNode("p", { class: "mx-auto mt-2 text-lg font-medium text-center text-clay-800" }, "Can you tell us why you canceled?", -1)),
                        _createElementVNode("div", _hoisted_25, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(reasonOptions, (reason) => {
                            return _createElementVNode("div", _hoisted_26, [
                              _withDirectives(_createElementVNode("input", {
                                id: reason,
                                name: reason,
                                value: reason,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedReason).value = $event)),
                                type: "radio",
                                class: "w-4 h-4 border-2 border-gray-500 text-clay-600 focus:ring-clay-500"
                              }, null, 8, _hoisted_27), [
                                [_vModelRadio, selectedReason.value]
                              ]),
                              _createElementVNode("label", {
                                for: reason,
                                class: "ml-3"
                              }, [
                                _createElementVNode("span", _hoisted_29, _toDisplayString(reason), 1)
                              ], 8, _hoisted_28)
                            ])
                          }), 64)),
                          _createElementVNode("div", null, [
                            _cache[20] || (_cache[20] = _createElementVNode("label", {
                              class: "block font-medium text-gray-700",
                              for: "comment"
                            }, "If you don't mind, we would love to know what we can do to make StageAgent more useful?", -1)),
                            _createElementVNode("div", _hoisted_30, [
                              _withDirectives(_createElementVNode("textarea", {
                                id: "comment",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((comments).value = $event)),
                                class: "block w-full rounded-md bg-white px-3 py-1.5 text-base text-clay-900 outline-1 -outline-offset-1 outline-clay-300 placeholder:text-clay-900 focus:outline-2 focus:-outline-offset-2 focus:outline-clay-600 sm:text-sm/6",
                                name: "comment",
                                rows: "4"
                              }, null, 512), [
                                [_vModelText, comments.value]
                              ])
                            ]),
                            _createElementVNode("button", {
                              class: "inline-flex justify-center px-5 py-2 mt-10 text-lg font-medium text-white border border-transparent rounded-md shadow-sm bg-powder-600 hover:border hover:bg-powder-500 hover:outline-hidden hover:ring-2 hover:ring-offset-2 focus:ring-powder-900 text-md",
                              type: "submit",
                              onClick: _withModifiers(submitSurvey, ["prevent"])
                            }, " Submit")
                          ])
                        ])
                      ]))
                ])
              ])
            ])
          ]))
    ])
  ]))
}
}

})